import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ReceiptCent } from "lucide-react";
import { Create, DateInput, SimpleForm } from "../../common";
import { StatusSelectInput } from "../../../documents/shared/StatusSelectInput";

const statusChoices = [
  { id: "draft", name: "Draft" },
  { id: "processing", name: "Processing" },
  { id: "approved", name: "Approved" },
  { id: "paid", name: "Paid" },
];

export const PayrollRunCreate = () => (
  <Create title="Create Payroll Run">
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <ReceiptCent className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Initiate Payroll Run</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <DateInput
              source="period_month"
              label="Period Month"
              helperText="Use the first day of the payroll month."
            />
            <StatusSelectInput
              source="status"
              choices={statusChoices}
              defaultValue="draft"
            />
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Create>
);
